export const opportunityFilterKey = 'custom.filter.opportunity'